import { render, staticRenderFns } from "./tempArchives.vue?vue&type=template&id=1cd6ba1d&scoped=true&"
import script from "./tempArchives.vue?vue&type=script&lang=js&"
export * from "./tempArchives.vue?vue&type=script&lang=js&"
import style0 from "./tempArchives.vue?vue&type=style&index=0&id=1cd6ba1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd6ba1d",
  null
  
)

export default component.exports